export type SpecielMatchReferee = {
  id: string;
  referee: Referee;
  match: string;
  tournament: Tournament
};

export type Referee = {
  id: string;
  name: string;
  tournament: Tournament;
  matchRefId?: string;
};

export type Player = {
  id: string;
  name: string;
  birthday: number | null;
  team: TeamType;
  tournament: Tournament;
  user: User;
  number: string;
};

export type MatchEvent = {
  id: string;
  match: Match;
  team: TeamType;
  player?: Player | null;
  eventNumber: number;
  eventType: EVENT_TYPE;
};

export type dbMatchEvent = {
  id: string;
  match: string;
  team: string;
  player?: string | null;
  tournament: string;
  eventNumber: number;
  eventType: EVENT_TYPE;
};

export type Tournament = {
  id: string;
  name: string;
  date: number;
  link: string | null;
  isActive: boolean;
  showInTournamentDates: boolean;
  isGoingLive: boolean;
};

export type Settings = {
  gapTime: number | null;
  id: string;
  isPublic: boolean;
  rules: string | null;
  text: string | null;
  title: string | null;
  tournament: string | null;
};

export type Match = {
  id: string;
  homeTeam?: TeamType;
  awayTeam?: TeamType;
  homeTeamEvents: MatchEvent[];
  awayTeamEvents: MatchEvent[];
  status: STATUS;
  startTime: number;
  endTime: number;
  location: LocationType;
  matchType: MATCH_TYPE;
  group?: GroupType;
  knockoutMatchId?: string;
  pulje: Pulje;
  tournament: Tournament;
  homeTeamLabel?: string;
  awayTeamLabel?: string;
  duration: number;
  referees: SpecielMatchReferee[];
};

export enum MATCH_TYPE {
  GROUP_MATCH = "GROUP_MATCH",
  KNOCKOUT_MATCH = "KNOCKOUT_MATCH",
}

export type TeamType = {
  id: string;
  teamName: string;
  group?: GroupType;
  club?: Club;
};

export type Club = {
  id: string;
  name: string;
  logo?: string | null;
  nationality: NATIONALITY;
};

export type UpdateTeamType = {
  teamName: string;
  group: string;
  club?: string | null;
};

export type GroupType = {
  id: string;
  name: string;
  teams?: Array<TeamType>;
  pulje: Pulje;
};

export enum STATUS {
  PENDING = "PENDING",
  PLAYING = "PLAYING",
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export enum KNOCK_OUT_TOURNAMENT_SIZE {
  NONE = "NONE",
  MINI = "MINI",
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
}

export enum KNOCK_OUT_MATCH_TYPE {
  ROUND_OF_16 = "Round of 16",
  QUARTER_FINAL = "Quarter-final",
  SEMI_FINAL = "Semi-final",
  THIRD = "Third place",
  FINAL = "Final",
}

export type LocationType = {
  id: string;
  location: string;
  tournament: Tournament;
  delay: number;
  order: number;
  liveStreamUrl?: string | null;
};

export enum PULJE_TYPE {
  SENIOR = "SENIOR",
  U18 = "U18",
  OLDBOYS = "OLDBOYS",
  WOMEN = "WOMEN",
  OTHER = "OTHER",
}

export enum ROLES {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  EDITOR = "EDITOR",
  PLAYER = "PLAYER",
}

export enum EVENT_TYPE {
  GOAL = "GOAL",
  YELLOW_CARD = "YELLOW_CARD",
  RED_CARD = "RED_CARD",
}

export type Pulje = {
  groupMatchTime: number;
  id: string;
  knockoutMatchTime: number;
  puljeName: string;
  puljeSize: KNOCK_OUT_TOURNAMENT_SIZE;
  tournament: Tournament;
  puljeType: PULJE_TYPE
};

export type dbPulje = {
  groupMatchTime: number;
  id: string;
  knockoutMatchTime: number;
  puljeName: string;
  puljeSize: KNOCK_OUT_TOURNAMENT_SIZE;
  tournament: string;
};

export interface User {
  id: string;
  email: string | null;
  role: ROLES;
  firstname?: string | null;
  lastname?: string | null;
  number?: string | null;
  birthday?: number | null;
}

export enum NATIONALITY {
  DENMARK = "DENMARK",
  SWEDEN = "SWEDEN",
  NORWAY = "NORWAY",
  ENGLAND = "ENGLAND",
  GERMANY = "GERMANY",
  FRANCE = "FRANCE",
  SWITZERLAND = "SWITZERLAND",
}

export type Severity = "error" | "warning" | "success" | "info";


export type TournamentEvent = {
  id: string;
  tournament: Tournament;
  title: string;
  startTime: number;
  endTime: number;
  location: LocationType
  status: STATUS;
  duration: number;
};
